<template>
    <v-container class="mt-16">
        <div class="spinner" v-if="loading">
            <v-row>
                <v-col cols="12" align="center">
                    <v-progress-circular :width="3" :size="25" color="green" indeterminate class="mr-2"></v-progress-circular>
                    <span>loading...</span>
                </v-col>
            </v-row>  
        </div>
        <v-card class="ma-0 pa-0" v-if="!loading">
            <v-row>
                <v-col cols="3">
                    <v-checkbox v-model="expert" :label="'My actions only'" @change="filterActions()" class="pl-4"/>
                </v-col>
                <v-col cols="6">
                    <v-card-title class="justify-center">List of all accommodation actions</v-card-title>
                </v-col>
                <v-col cols="1">
                </v-col>
                <v-col cols="2">
                    <v-checkbox v-model="realtest" :label="'Include test accommodations'" @change="filterActions()" class="pl-4"/>
                </v-col>
            </v-row>
            <v-divider/>
            <v-row>
                <v-col cols="3" class="pa-4">
                    <v-text-field v-model="search" label="Search in actions" single-line hide-details dense prepend-icon="mdi-magnify"></v-text-field>
                </v-col>
            </v-row>
            <v-divider/>
            <v-data-table 
                dense
                :items="filteredItems" 
                :items-per-page="20" 
                :footer-props="{'items-per-page-options': [10, 20, 50, 100, 200, -1]}"
                :headers="headers"
                :search="search"
                :custom-filter="customSearch">
                <template v-slot:item="props">
                    <tr>
                        <td :class="getClass(props.item)"><span class="spanClick" @click="openTab('/huis/onHuis/' + props.item.huis_encrid)">{{ props.item.huis_code }}</span></td>
                        <td :class="getClass(props.item)">{{ props.item.huis_naam }}</td>
                        <td :class="getClass(props.item)">{{ props.item.huis_gebr_naam }}</td>
                        <td :class="getClass(props.item)">{{ props.item.huis_actie_datum }}</td>
                        <td :class="getClass(props.item)">{{ props.item.huis_actie_opm }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <navBar title="Ares - Main menu" :home="true" :accolist="true" type="main"/>
    </v-container>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue";

    export default {
        components: {
            navBar,
        },
        data() {
            return {
                loading: true,
                realtest: false,
                expert: true,
                vandaag: "",
                vandaag3: "",
                search: "",
                items: [],
                filteredItems: [],
                headers: [
                    { text: "Accommodation code", value: "huis_code" },
                    { text: "Accommodation name", value: "huis_naam" },
                    { text: "Rental expert", value: "huis_gebr_naam" },
                    { text: "Action date", value: "huis_actie_datum" },
                    { text: "Action", value: "huis_actie_opm" },
                ]
            }
        },
        mounted() {
            this.maakDatum();
            let vandaag = new Date();
            this.vandaag = vandaag.toISOString().substring(0, 10);
            //console.log(this.vandaag)
            vandaag = this.addDays(vandaag, 3)
            //console.log(vandaag)
            this.vandaag3 = vandaag.toISOString().substring(0, 10);
            //console.log(this.vandaag3)

            this.actionsList();
        },
        methods: {
            addDays(date, days) { 
                date.setDate(date.getDate() + days);
                return date; 
            },
            maakDatum () {
            },
            getClass(item) {
                if (item.huis_actie_datum_iso < this.vandaag) {
                    return "actionLate";
                }
                if (item.huis_actie_datum_iso <= this.vandaag3) {
                    return "actionWarn";
                }
                return "";
            },
            filterActions() {
                if (this.realtest&&!this.expert) {
                    this.filteredItems = this.items;
                    return
                }
                let newItems = [];
                // let user = localStorage.getItem('login');
                for (let iIndex=0;iIndex<this.items.length;iIndex++) {
                    let AddItem = true;
                    if ((!this.realtest) && (this.items[iIndex].huis_realtest!=="Real")) {
                        AddItem = false;
                    }
                    if (this.expert && (!this.items[iIndex].huis_own_action)) {
                        AddItem = false;
                    }
                    if (AddItem) {
                        newItems.push(this.items[iIndex]);
                    }
                }
                this.filteredItems = newItems;
            },
            customSearch (value, search, item) {
                return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search.toLowerCase()))
            },
            openTab(url) {
                if (url !== "") {
                    this.$router.open(url);
                }
            },
            actionsList() {
                this.loading = true;
                this.$axios.post("ares/json/ares/huis/ovrz/actionsList.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "actionsList"
                    },
                    actionsList: {
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.loading = false;
                    } else {
                        this.items = res.data.actionsList;
                        this.filterActions();
                        this.loading = false;
                    }
                });
            },
        },
    }

</script> 

<style scoped> 
    .spanClick {
        cursor: pointer;
        text-decoration: underline;
        color: blue;
    }
    .actionLate {
        color: red;
    }
    .actionWarn {
        color: orange;
    }
</style>

